var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _path, _path2, _circle7, _path3, _circle8, _path4, _circle9, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _path7, _ellipse4, _ellipse5, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _ellipse6, _ellipse7, _path18, _path19, _path20, _ellipse8, _ellipse9, _path21, _path22, _path23, _ellipse0, _ellipse1, _path24, _path25, _path26, _path27, _path28, _circle0, _path29, _path30, _path31, _path32, _path33, _path34, _circle1, _path35, _path36;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCloudDollarBills = function SvgCloudDollarBills(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    "aria-hidden": "true",
    clipRule: "evenodd",
    viewBox: "0 0 242 248"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 121,
    cy: 129.5,
    r: 105.5,
    fill: "#e6f5ff",
    stroke: "#18191b"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 226 201.5)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 1.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 27 50.5)"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 216.5,
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "rotate(90 25 216.5)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 2.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 229 89.5)"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 3.5,
    fill: "none",
    stroke: "#18191b",
    transform: "matrix(0 1 1 0 49 36.5)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    d: "M23.318 196.818a.318.318 0 0 1 0-.636h1.364v-1.364a.318.318 0 0 1 .636 0v1.364h1.364a.318.318 0 0 1 0 .636h-1.364v1.364a.318.318 0 1 1-.636 0v-1.364z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "M37 212a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 37 212zM138 16.5a1.5 1.5 0 1 1 .001-3.001A1.5 1.5 0 0 1 138 16.5z"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 217,
    cy: 172.5,
    r: 14.5,
    fill: "#84e1bc",
    stroke: "#18191b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M224.5 179v-11a2 2 0 0 0-2-2h-1v-1c0-.551-.449-1-1-1h-1c-.551 0-1 .449-1 1v1h-3v-1c0-.551-.449-1-1-1h-1c-.551 0-1 .449-1 1v1h-1a2 2 0 0 0-2 2v11a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2zm-4-5v-1h1v1zm0 4v-1h1v1zm-4-4v-1h1v1zm0 4v-1h1v1zm-4-4v-1h1v1zm0 4v-1h1v1z"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 89,
    r: 15,
    fill: "#84e1bc",
    stroke: "#18191b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M21 81.25v3.281a5.98 5.98 0 0 0-1.5 3.969 5.98 5.98 0 0 0 1.5 3.969v3.281c0 .692.558 1.25 1.25 1.25h6.5c.692 0 1.25-.558 1.25-1.25v-3.281a5.98 5.98 0 0 0 1.5-3.969 5.98 5.98 0 0 0-1.5-3.969V81.25c0-.692-.558-1.25-1.25-1.25h-6.5c-.692 0-1.25.558-1.25 1.25zm4.875 4.375v3.036l.206.149 1.186.864-.441.608-1.701-1.239v-3.418z"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.5,
    cy: 170,
    r: 15,
    fill: "#7ec4f6",
    stroke: "#18191b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "m22.584 163.777.148.223h.136l-.116.066c-3.255 1.856-4.832 4.039-5.585 5.869-.694 1.69-.672 3.049-.665 3.48l.001.085c0 1.993 1.823 3.5 3.927 3.5h9.14c2.105 0 3.928-1.507 3.928-3.5l.001-.076c.005-.421.024-1.789-.679-3.493-.757-1.832-2.333-4.019-5.572-5.865l-.115-.066h.135l.148-.223 1.481-2.222a1 1 0 0 0-.832-1.555h-6.129a1 1 0 0 0-.832 1.555zm2.949 8.911-.489.011v.8h-.088v-.792l-.474-.024a1.5 1.5 0 0 1-.545-.135l.054-.052c.174.081.363.123.555.124h.958c.543 0 .901-.471.901-.944 0-.394-.241-.787-.659-.908l-1.529-.453a1.025 1.025 0 0 1-.717-.982c0-.559.437-1.002.967-1.018l.485-.014v-.801h.089v.793l.475.024c.19.01.376.056.548.137l-.056.053a1.3 1.3 0 0 0-.553-.123h-.958c-.542 0-.901.47-.901.944 0 .394.242.787.659.908l1.529.453c.415.123.716.523.717.98-.004.564-.446 1.006-.968 1.019zm.75-4.445.003-.003zm45.761-97.037-4.375-6.508 2.202-2.48 4.703 6.577z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.966,
    ry: 0.828,
    transform: "scale(1 -1)rotate(-75.478 -7.62 -79.122)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.483,
    ry: 0.414,
    transform: "scale(1 -1)rotate(-75.478 -7.066 -77.484)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.483,
    ry: 0.414,
    transform: "scale(1 -1)rotate(-75.478 -8.224 -81.007)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "m183.885 110.512-4.79 14.307 5.352 3.475 5.364-14.604z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M184.038 118.18c.535-.009 1.102.516 1.114 1.341.013.826-.538 1.367-1.072 1.375s-1.101-.516-1.114-1.341c-.012-.825.538-1.367 1.072-1.375z"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 182.792,
    cy: 123.407,
    fill: "#31c48d",
    rx: 0.929,
    ry: 0.797,
    transform: "rotate(-90.882 182.792 123.407)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 185.585,
    cy: 115.133,
    fill: "#31c48d",
    rx: 0.929,
    ry: 0.797,
    transform: "rotate(-90.882 185.585 115.133)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M189.707 109.287c.569-2.632 1.221-4.771 2.577-6.837m-5.224 2.09c.205-1.028.421-2.035.713-3.04"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    d: "m154.403 10.625-10.102 26.79 9.903 6.973 11.211-27.313z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M154.158 24.727c1.323.03 2.494 1.336 2.455 3.082-.038 1.747-1.266 3-2.589 2.971-1.324-.029-2.494-1.336-2.456-3.082.039-1.747 1.266-3 2.59-2.971zm-2.719 9.012c.489.011 1 .513.983 1.286-.017.772-.55 1.251-1.039 1.241-.489-.011-1.001-.513-.984-1.286s.551-1.252 1.04-1.241zm5.886-15.494c.489.011 1.001.513.984 1.286s-.551 1.252-1.04 1.241-1-.513-.983-1.286c.017-.772.55-1.251 1.039-1.241z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M165.354 11.471c.355-2.721.346-5.055-.188-7.725m2.825 18.087c2.457-3.213 3.015-7.729 3.015-11.681"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    d: "m92.151 43.825 20.761 19.717-5.878 10.59-21.987-19.705z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M98.513 56.414c-1.179.603-1.664 2.289-.869 3.844.796 1.555 2.446 2.149 3.625 1.546s1.664-2.289.868-3.844-2.446-2.149-3.624-1.546zm6.372 6.927c-.435.223-.677.898-.325 1.586s1.04.887 1.476.664.677-.897.325-1.585-1.04-.887-1.476-.665zM92.838 51.959c-.435.222-.677.897-.325 1.585s1.041.887 1.476.665c.436-.223.677-.898.325-1.586s-1.04-.887-1.476-.664z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M79.931 27c.205 3.33 1.177 6.77 2.082 9.974.289 1.021.57 2.203 1.042 3.147m-8.539-18.744c.268 9.201 2.125 18.621 6.248 26.866"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    d: "m64.741 101.44 13.215 17.299-5.686 7.243-14.137-17.437z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M68.041 111.77c-.879.285-1.433 1.413-1.037 2.63.395 1.217 1.505 1.805 2.384 1.52.879-.286 1.432-1.413 1.037-2.631s-1.506-1.804-2.384-1.519zm3.951 5.967c-.275.089-.524.487-.358 1s.602.689.877.599.525-.487.358-1c-.166-.513-.602-.688-.877-.599zm-7.675-9.994c-.275.089-.524.487-.358 1s.603.688.878.599c.274-.089.524-.487.357-1-.166-.513-.602-.688-.877-.599z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M62.404 97.919c-1.161-2.868-1.697-5.69-1.697-8.766m-1.979 9.332c-.303-.747-.987-3.604-1.697-3.959"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "m134.781 79.055 7.483-13.101-4.574-4.451-8.103 13.281z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M136.123 71.504c-.526-.095-.98-.72-.832-1.532s.794-1.236 1.32-1.141c.525.096.979.721.831 1.533s-.794 1.236-1.319 1.14z"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 138.363,
    cy: 66.619,
    fill: "#31c48d",
    rx: 0.929,
    ry: 0.797,
    transform: "rotate(100.342 138.363 66.619)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 134.012,
    cy: 74.192,
    fill: "#31c48d",
    rx: 0.929,
    ry: 0.797,
    transform: "rotate(100.342 134.012 74.192)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M132.325 59.872c-2.134-2.903-.867-7.102-.867-10.4m3.581 8.568c-.362-.929-.637-1.981-.637-2.975"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "m113.961 34.953-8.759-13.028 4.409-4.967 9.416 13.168z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M112 27.238c.552-.143.978-.839.761-1.678-.217-.84-.929-1.241-1.48-1.098-.552.143-.979.839-.761 1.678.217.84.928 1.241 1.48 1.098z"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.967,
    ry: 0.829,
    transform: "scale(1 -1)rotate(-75.478 40.231 -81.768)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.967,
    ry: 0.829,
    transform: "scale(1 -1)rotate(-75.478 37.913 -88.821)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M114.301 15.716c0-.625-.07-1.29.091-1.9.09-.344.271-.64.271-.996m-3.801.363c.357-2.231.999-4.2 2.172-6.154"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "m91.888 90.602 14.816 5.189-.557 6.618-15.427-4.907z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M98.077 95.607c-.356.445-.281 1.258.396 1.8s1.487.438 1.843-.007.281-1.258-.396-1.8-1.486-.437-1.843.007z"
  })), _ellipse0 || (_ellipse0 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.967,
    ry: 0.829,
    transform: "scale(-1 1)rotate(-38.692 87.869 195.914)"
  })), _ellipse1 || (_ellipse1 = /*#__PURE__*/React.createElement("ellipse", {
    fill: "#31c48d",
    rx: 0.967,
    ry: 0.829,
    transform: "scale(-1 1)rotate(-38.692 87.915 182.197)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M102.097 88.711c-.58-1.934-.276-3.738-.136-5.718m-3.274 5.941c-.191-3.113-.204-5.513.749-8.434"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#bcf0da",
    stroke: "#18191b",
    d: "m132.534 113.837 19.401-21.056 10.677 5.717-19.371 22.282z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#31c48d",
    stroke: "#18191b",
    d: "M145.025 107.285c.62 1.17 2.313 1.629 3.856.811 1.544-.819 2.112-2.479 1.492-3.648s-2.314-1.629-3.857-.81-2.112 2.478-1.491 3.647zm6.831-6.476c.229.432.907.663 1.59.301s.871-1.054.642-1.486-.907-.663-1.59-.301-.871 1.054-.642 1.486zm-11.2 12.217c.229.432.907.664 1.59.301.683-.362.871-1.053.642-1.485s-.908-.664-1.59-.302c-.683.362-.872 1.054-.642 1.486z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M156.781 89.689c1.449-1.913 2.364-4.176 3.124-6.457m3.296 8.153c1.613-2.95 2.838-5.993 3.627-9.27.518-2.153 1.121-4.276 1.121-6.5"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M72 141.5h100v73H72z"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 164.5,
    cy: 204,
    r: 0.5,
    fill: "#18191b",
    transform: "rotate(-90 164.5 204)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M81 156.5H64v2.837l2.833 1.134v51.058L64 212.663v2.837h17v-2.837l-2.833-1.134v-51.058L81 159.337zm77 0h-19v2.837l3.167 1.134v51.058L139 212.663v2.837h19v-2.837l-3.167-1.134v-51.058l3.167-1.134zm-53 0H86v2.837l3.167 1.134v51.058L86 212.663v2.837h19v-2.837l-3.167-1.134v-51.058l3.167-1.134zm75 0h-17v2.837l2.833 1.134v51.058L163 212.663v2.837h17v-2.837l-2.833-1.134v-51.058l2.833-1.134z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M58.5 215h127v6h-127zM194.5 149.772h-7.3V157H56.8v-7.228h-7.3v-4.92l73.309-23.826L194.5 144.85z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "M188 149.78H56"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#18191b",
    d: "M52.5 221h139v6h-139z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "#18191b",
    stroke: "#18191b",
    d: "M112 186.45v28.05h21v-28.05s0-5.95-10.5-5.95-10.5 5.95-10.5 5.95z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "m153 142.5-30.427-11L91 142.5"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 199,
    cy: 54.5,
    r: 32.5,
    fill: "#7ec4f6",
    stroke: "#18191b"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m179 54.395 3.154-10.421 12.615-3.474h9.462l12.615 3.474L220 54.395l-18.088 16.69L199.5 73.5l-2.412-2.415z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#18191b",
    d: "m179 54.395 3.154-10.421 12.615-3.474M179 54.395h10.789m-10.789 0 18.088 16.69M194.769 40.5h9.462m-9.462 0-4.98 13.895M204.231 40.5l12.615 3.474L220 54.395M204.231 40.5l4.98 13.895m10.789 0h-10.789m10.789 0-18.088 16.69m7.299-16.69-7.299 16.69m7.299-16.69h-19.422m12.123 16.69L199.5 73.5l-2.412-2.415m-7.299-16.69 7.299 16.69"
  })));
};
export default SvgCloudDollarBills;